import { Form } from 'formik';
import styled from 'styled-components';
import { Button, Box } from '@rsos/components/capstone/base';

const LOGIN_WRAPPER_WIDTH = 280;
const CARD_BG = '#f7f7f7';
const PAGE_TOP_BG = '#f7f7f7';
const PAGE_BOTTOM_BG = '#ffffff';

/**
 * StyledPage is needed to override the default page background color and height
 * due to Bulma defaults. Can be removed once we remove Bulma.
 */
export const StyledPage = styled.div`
  && {
    html &,
    body & {
      background: ${({ theme }) => theme.colors.background};
      padding: 0;
      margin: 0;
      height: 100vh;
    }
  }
`;

export const LoginWrapper = styled(Box)`
  width: ${LOGIN_WRAPPER_WIDTH}px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const LoginButton = styled(Button).attrs({
  btnType: 'primary',
  type: 'submit',
  noMargin: true,
  size: 'large',
  grow: true,
})`
  && {
    background-color: black;
    border-color: black;

    &:hover {
      background-color: #2d2d2d;
      border-color: black;
    }
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 60px;
`;

export const LoginBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 360px;
  padding: 64px 32px;
  background-color: ${CARD_BG};
`;

// Notched label that sits on the top-left corner of the email input, straddling
// its top border. The chip background matches the surrounding card so the input
// border appears "cut" behind the label.
export const EmailField = styled.div`
  position: relative;
  width: 100%;

  /* Browsers paint their own background on autofilled inputs and enforce it with
     !important, so it can't be unset directly. The inset box-shadow trick paints
     over that background with the input's own color, and the long transition
     keeps the autofill color from flashing back in. */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.background}
      inset !important;
    box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.background} inset !important;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.colors.primaryText} !important;
    caret-color: ${({ theme }) => theme.colors.primaryText};
    transition: background-color 9999s ease-in-out 0s;
  }
`;

export const EmailLabel = styled.label`
  position: absolute;
  top: 0;
  left: 10px;
  transform: translateY(-50%);
  z-index: 1;
  padding: 0 6px;
  background: linear-gradient(
    to bottom,
    ${PAGE_TOP_BG} 0%,
    ${PAGE_TOP_BG} 50%,
    ${PAGE_BOTTOM_BG} 50%,
    ${PAGE_BOTTOM_BG} 100%
  );
  color: ${({ theme }) => theme.colors.secondaryText};
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 1;
`;
